import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import {setFilteredCustomers, setSearchedCustomers} from '../../../../../setup/slices/AnavezneSlice'
import {AnaVezneCustomersCall} from '../../apis/ApiCall'

interface Props {
  stores: any
  setCustomers: any
  setCurrentStore: React.Dispatch<React.SetStateAction<{AnavezneKodu: string; AnavezneAdi: string}>>
  setIsLoading: React.Dispatch<React.SetStateAction<boolean | undefined>>
}

const CustomerFilter: React.FC<Props> = ({stores, setCustomers, setCurrentStore, setIsLoading}) => {
  const dispatch = useDispatch()
  const allCustomers = useSelector((state: RootState) => state.customers.allCustomers)
  const filteredCustomers = useSelector((state: RootState) => state.customers.filteredCustomers)

  const [filteredValue, setFilteredValue] = useState<number>(3917462855)

  useEffect(() => {
    dispatch(setSearchedCustomers(filteredCustomers))
  }, [filteredCustomers])

  useEffect(() => {
    if (filteredValue !== 3917462855) {
      AnaVezneCustomersCall(setCustomers, setIsLoading)
    }
  }, [filteredValue])

  useEffect(() => {
    let fromAllCustomers: any[] = allCustomers.filter(
      (customer: any) => parseInt(customer.StoreId) === filteredValue && customer.StoreId !== null
    )
    switch (filteredValue) {
      case 0:
        dispatch(setFilteredCustomers(allCustomers))
        break
      case 1:
        dispatch(
          setFilteredCustomers(
            allCustomers.filter((customer: any) => typeof customer.StoreId !== typeof 0.0)
          )
        )
        break
      default:
        dispatch(setFilteredCustomers(fromAllCustomers))
        break
    }
  }, [allCustomers, dispatch, filteredValue])

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsLoading(true)
    setFilteredValue(parseInt(event.target.value))
    if (event.target.value === '0') {
      setCurrentStore({AnavezneKodu: '', AnavezneAdi: ''})
    } else {
      stores.Detail.map((store: any) => {
        //if(event.target.value === store.CustomerReference) {
        setCurrentStore({AnavezneKodu: store.CustomerReference, AnavezneAdi: store.DisplayName})
        //}
      })
    }
  }

  return (
    <div className='pt-7'>
      <label htmlFor='select' className='mb-2 fs-6 fw-bolder text-gray-700'>
        Ana Vezne Seçme:
      </label>
      <div className='fv-row'>
        <select
          id='dropdownBar'
          className='form-select form-select-solid form-select-lg'
          onChange={(e) => handleSelect(e)}
          defaultValue={3917462855}
        >
          <option value={3917462855} disabled>
            Lütfen Seçim Yapınız...
          </option>
          <option value={0}>Hepsi</option>
          <option value={1}>Vezne Atanmayan Müşteriler</option>
          {stores.Detail.map((store: any, index: number) => (
            <option value={store.CustomerReference} key={index}>
              {store.CustomerReference} - {store.DisplayName}
            </option>
          ))}
        </select>
      </div>{' '}
    </div>
  )
}

export default CustomerFilter
